import { Blurhash } from "react-blurhash";

import { cn } from "@/lib/utils";

export interface PhotoWithBlurhashProps {
  url: string;
  blurhash: string;
  className?: string;
  parentClassName?: string;
}

export const PhotoWithBlurhash = ({
  url,
  blurhash,
  className,
  parentClassName,
}: PhotoWithBlurhashProps) => {
  return (
    <div key={url} className={cn("grid group", parentClassName)}>
      <img
        className={cn(
          "col-start-1 row-start-1 group-hover:invisible",
          className,
        )}
        src={url}
      />
      {blurhash.length < 6 ? (
        <></>
      ) : (
        <Blurhash
          className="col-start-1 row-start-1 group-hover:visible invisible"
          hash={blurhash}
          width={"100%"}
          height={"100%"}
        />
      )}
    </div>
  );
};
